export const logInfo = (msg: string) => {
  msg = `%c [info]: ${msg}`;
  console.info(msg, "color: #f69720");
};

export const logError = (msg: string) => {
  msg = `%c [error]: ${msg}`;
  console.info(msg, "color: red");
};
